import React from "react";
import { Link } from "react-router-dom";
import { slugify } from "../../../utils";

const PropOne = ({ projectStyle, portfolio }) => {
  const detailUrl = portfolio.systemSlug
    ? process.env.PUBLIC_URL + `/systems/${portfolio.systemSlug}`
    : process.env.PUBLIC_URL + `/project-details/${slugify(portfolio.title)}`;

  return (
    <>
      <div className={`project-grid ${projectStyle}`}>
        <div className="thumbnail">
          <Link to={detailUrl}>
            <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" />
          </Link>
        </div>
        <div className="content">
          <h4 className="title">
            <Link to={detailUrl}>
              {portfolio.title}
            </Link>
          </h4>
          <span className="subtitle">
            {portfolio.body.map((bod, i) => (
              <span key={i}>{bod}</span>
            ))}
          </span>
        </div>
      </div>
    </>
  );
};

export default PropOne;
